export const phoneColumnNames = [
    'phone',
    'client_phone',
    'dealer_phone',
    'manager_phone',
    'candidate'
]